import LegalLayout, { H2, P } from "./LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" lastUpdated="Juin 2026 — Version 1.2">
      <H2>Éditeur du site et du logiciel</H2>
      <P>
        <b>MJSA INVEST</b><br />
        Forme juridique : Société à responsabilité limitée (SARL) – Société à associé unique – Holding<br />
        Siège social : 13 Rue Denis Papin, 51100 Reims<br />
        SIREN : 831 701 867<br />
        RCS : 831 701 867 R.C.S. Reims<br />
        Capital social : 446 862,00 €<br />
        TVA intracommunautaire : FR27831701867<br />
        Directeur de la publication : Julien PINOT<br />
        Email : <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>
      </P>

      <H2>Hébergement</H2>
      <P>
        Le logiciel PitBoard et ses données sont hébergés par :<br/>
        <b>IONOS SE</b> — 8 rue de la Ville l&apos;Évêque, 75008 Paris (France).<br/>
        Localisation des données : Union Européenne (France / Allemagne).
      </P>
      <P>
        MJSA INVEST s&apos;engage à ce que les données des utilisateurs soient hébergées
        exclusivement sur le territoire de l&apos;Union Européenne, conformément aux exigences
        du RGPD et aux recommandations de la CNIL.
      </P>

      <H2>Propriété intellectuelle</H2>
      <P>
        L&apos;ensemble des éléments composant le service PitBoard (textes, graphismes, logo,
        code source, bases de données, marque « PitBoard ») sont la propriété exclusive de
        MJSA INVEST et sont protégés par les lois françaises et internationales relatives à
        la propriété intellectuelle, notamment les articles L.111-1 et suivants (droit
        d&apos;auteur) et L.341-1 et suivants (bases de données) du Code de la propriété
        intellectuelle. Toute reproduction, représentation, modification, publication,
        transmission, dénaturation, totale ou partielle, sans autorisation écrite préalable
        de MJSA INVEST est strictement interdite.
      </P>

      <H2>Données personnelles (RGPD)</H2>
      <P>
        Pour toute question relative à vos données personnelles ou à l&apos;exercice de vos
        droits (accès, rectification, effacement, portabilité, opposition) :
        {" "}<a href="mailto:dpo@pitboard-app.fr" className="underline">dpo@pitboard-app.fr</a>
        {" "}ou par courrier au siège social.<br/>
        Détail dans la <a href="/confidentialite" className="underline">Politique de confidentialité</a>.<br/>
        Autorité de contrôle : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="underline">CNIL</a> – 3 Place de Fontenoy, 75007 Paris.
      </P>

      <H2>Crédits</H2>
      <P>
        Icônes : <a href="https://lucide.dev/" target="_blank" rel="noopener noreferrer" className="underline">Lucide</a> (licence ISC).
        Polices : <a href="https://fonts.google.com/specimen/Fraunces" target="_blank" rel="noopener noreferrer" className="underline">Fraunces</a> et <a href="https://fonts.google.com/specimen/Inter" target="_blank" rel="noopener noreferrer" className="underline">Inter</a> (Google Fonts).
      </P>

      <H2>Médiateur de la consommation</H2>
      <P>
        Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, MJSA INVEST
        propose un dispositif de médiation. Entité retenue : Médiateur du Tribunal de
        Commerce de Reims, 55-57 rue Thiers, CS 80034, 51724 Reims Cedex. Coordonnées
        disponibles sur demande à
        {" "}<a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
      </P>

      <H2>Plateforme européenne de règlement en ligne des litiges</H2>
      <P>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="underline">ec.europa.eu/consumers/odr</a>
      </P>
    </LegalLayout>
  );
}
